<template>
  <main-layout>
    <div class="weChatPay">
      <div class="payBox">
        <p class="price">
          {{$t('live.实付金额')}}：<span><i>¥</i>{{ price }}</span>
        </p>
        <p class="time">{{$t('live.请在15分钟内完成付款')}}</p>
        <div class="code">
          <div id="qrcode" ref="qrcode"></div>
          <img v-if="isShow" @click="getInit" src="https://image.manamana.net/1655363627000_QhRDgshM" alt="">
        </div>
        <p class="title">{{$t('live.请使用微信扫一扫')}}</p>
        <p class="title">{{$t('live.扫描二维码以完成支付')}}</p>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import QRCode from "qrcodejs2";
import app from "@/main";
export default {
  metaInfo() {
    return {
      title: "MANA " + this.$t("live.微信付款")
    };
  },
  components: {
    MainLayout
  },
  data() {
    return {
      orderNo: null,
      price: null,
      code: null,
      qrcode: null,
      liveId: null,
      isShow: false
    };
  },

  methods: {
    getInit() {
      if (document.querySelector("#qrcode")) {
        document.querySelector("#qrcode").innerHTML = '';
      }
      this.isShow = false;
      var url = "";
      if (this.$route.query.type && this.$route.query.type == 1) {
        url = "/api/u/recruit/combo/pay";
      } else {
        url = "/api/bytedance/order/pay";
      }
      this.$http
        .post(url + "?payType=" + "WXPAY_NATIVE" + "&orderNo=" + this.orderNo, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          this.code = res.codeUrl;
          this.makeQrcode();
          this.getPay();
        });
    },
    makeQrcode() {
      this.qrcode = new QRCode(document.querySelector("#qrcode"), {
        width: 200,
        height: 200, // 高度
        text: this.code, // 二维码内容
        correctLevel: QRCode.CorrectLevel.H
      });
    },
    getPay() {
      this.$http
        .get(
          "/api/bytedance/order/query?orderNo=" + this.orderNo + "&platform=WX"
        )
        .then(res => {
          if (res.code == "OK") {
            if (res.data.orderStatusEnum == "SUCCESS") {
              if (this.$route.query.type && this.$route.query.type == 1) {
                this.$router.push(
                  "/live/paySuc?weChatId=" + res.data.orderId + "&type=3"
                );
              } else {
                this.$router.push("/live/paySuc?weChatId=" + res.data.orderId);
              }
            }
          }
          if (res.code == 5001) {
            this.isShow = true;
          }
        });
    }
  },

  created() {
    this.orderNo = this.$route.query.orderNo;
    this.price = this.$route.query.price;
    this.getInit();
  },
  mounted() {
    
  }
};
</script>
<style lang="stylus" scoped>
.weChatPay {
  background: #FAFAFA;
  padding: 80px 0 100px 0;

  .payBox {
    width: 920px;
    margin: 0 auto;
    background: #fff;
    text-align: center;
    padding: 46px 0;

    .price {
      height: 36px;
      font-size: 16px;
      font-weight: 400;
      color: #0A0A0A;
      line-height: 36px;

      span {
        height: 36px;
        font-size: 24px;
        font-weight: 600;
        color: #FC6240;
        line-height: 36px;
        i{
          font-weight: 400;
        }
      }
    }

    .time {
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 21px;
      margin: 10px 0 28px 0;
    }

    .code {
      width: 220px;
      height: 220px;
      border: 1px solid #E0E0E0;
      margin: 0 auto;
      margin-bottom: 36px;
      padding: 10px;
      box-sizing: border-box;
      position: relative;
      #qrcode {
      }
      img{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 80px;
        height: 80px;
      }
    }

    .title {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/weChat/weChat.vue